import { Component } from '@verndale/core';
import { ConditionalDisplay } from '../helpers/global';

class CTA extends Component {
  setupDefaults() {
    if (ConditionalDisplay(this.el.id)) {
      this.el.style.display = 'none';
      return;
    }
  }
}

export default CTA;
